<template>
    <v-data-table
            fixed-header
            v-model="selected"
            :headers="headers"
            :items="devices"
            :disable-pagination="true"
            item-key="deviceId"
            hide-default-footer
            :loading="loading"
            loading-text="Loading... Please wait"
            class="evelation-1 overflow-y-auto"/>
</template>

<script>

export default {
  name: 'Banks',
  data() {
    return {
      devices: [],
      apiUri: 'http://192.168.1.231/api',
      headers: [
        {text: 'DeviceName', value: 'deviceName'},
        {text: 'DeviceTypeName', value: 'deviceTypeName', },
        {text: 'SN', value: 'sn', },
        {text: 'BranchName', value: 'branchName', },
        {text: 'Link', value: 'link', },
        {text: 'Alias', value: 'alias', },
      ],
    };
  },
  async mounted(){
    await this.$axios.devices.get()
      .then(response => response.data)
      .then(json => {
        this.devices = json.slice(0, 100);
      }
      )
      .catch(e => {
        console.error(e);
      });        }
};
</script>

<style scoped>
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }
</style>